import { atomWithStorage, createJSONStorage } from 'jotai/utils';

// Stays app-side: the analytics models on the store graph read it, and the
// `@heidi/growth` door is an eager barrel.
const createSessionStorageAdapter = <T>() =>
  typeof globalThis.window === 'undefined'
    ? undefined
    : createJSONStorage<T>(() => globalThis.sessionStorage);

/**
 * The `session_id` of the current shortened-demo session, or `null` when the
 * user is not in a demo. Set when the user clicks "Try a demo" and read by
 * `analyticsScribeModel` to tag `transcription_*` and `note_*` events with
 * `demo_mode: 'shortened'` only when they belong to this session.
 *
 * Persisted via sessionStorage so events firing after a reload still tag
 * correctly. We never explicitly reset it — the sessionId comparison handles
 * cleanup naturally: events for any *other* session don't match and aren't
 * tagged, even though the atom still holds the original demo sessionId.
 */
export const currentDemoSessionIdAtom = atomWithStorage<string | null>(
  'demo-current-session-id',
  null,
  createSessionStorageAdapter<string | null>(),
  { getOnInit: true }
);
